import React, { useEffect, useRef, useState } from "react";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import "react-quill/dist/quill.snow.css";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import {
  decrementSteps,
  resetExperienceStepValues,
} from "../../../../Infrastructure/States/educatorStepsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  AboutMe,
  CharacterCount,
  ContinueButton,
  CountText,
  educatorFlowFooterSx,
  ErrorBlockLarge,
  ErrorBlockSmall,
  Footer,
  FullName,
  PreviousButton,
  TitleText,
} from "../../styles";
import ReactQuill from "react-quill";
import { UploadAvatar } from "./uploadAvatar";
import { httpsCallable } from "firebase/functions";
import { auth, database, functions } from "../../../../Infrastructure/config";
import { ShowErrorToast } from "../../../Common/Toast/toast";
import { DarkBgLoader, Loader } from "../../../Common/Loader/loader";
import { ref, update } from "firebase/database";
import * as Yup from "yup";
import { EduAccFlowHeader } from "../../../Common/EduAccFlowHeader/eduAccFlowHeader";
import { trackEvent } from "../../../../Infrastructure/Utilities/analytics";
import AnalyticsConstants from "../../../../Infrastructure/Constants/AnalyticsContants";
import { EducatorAgreement } from "../../../Common/EducatorAgreement/educatorAgreement";
import ERROR_CONSTANTS from "../../../../Infrastructure/Constants/errorConstants";
import { formats, modules } from "../../../../Infrastructure/Constants/reactQuillConstants";
import paths from "../../../../Infrastructure/Router/paths";
import { USER_LOGS_CLIENT } from "../../../../Infrastructure/Constants/logsConstant";
import { safeClientLogEvent } from "../../../../Infrastructure/Utilities/safeClientLogEvent";
import ScrollToTop from "../../../../Infrastructure/Helper/scrollToTop";
import { mobileStickySubmitSx } from "./Styles/mobileStickySubmit";
import { educatorProfileStepSX } from "./Styles/educatorProfileStepStyles";

export const EducatorProfileStep = ({ edit, setEdit, dashboard, lastPageRoute, urlInfoObj = {} }) => {
  const minCharacters = 200;
  const maxCharacters = 2000;
  const errorRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const uid = auth?.currentUser?.uid;
  // eslint-disable-next-line no-unused-vars
  const [errors, setErrors] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [touched, setTouched] = useState({});
  const ip = useSelector((state) => state.ip.address)
  const { title, subtitle, fromJob } = urlInfoObj
  const [isModalOpen, setModalOpen] = useState(false);
  const page = useSelector((state)=> state.route.currentRoute)
  const [agreementValue, setAgreementValue] = useState(edit ? true : null); // ← CHANGED
  const [loaderValue, setLoaderValue] = useState(false);
  const [exitLoading, setExitLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // ← ADDED
  const userData = useSelector((state) => state.userData.data);
  const aboutMe = userData?.educator?.profile?.about_me;
  // const profile = userData?.educator?.profile;
  // const youtube = profile?.youtube;
  // const linkedin = profile?.linkedin;
  // const twitter = profile?.twitter;
  // const website = profile?.website;
  const profilePicture = userData?.educator?.profile?.avatar;
  const firstName =
    userData?.account?.first_name.charAt(0).toUpperCase() +
    userData?.account?.first_name.slice(1);
  const lastName =
    userData?.account?.last_name.charAt(0).toUpperCase() +
    userData?.account?.last_name.slice(1);
  const loading = useSelector((state) => state.userData.loading);
  const [characterCount, setCharacterCount] = useState(0);
  const steps = useSelector((state) => state.educatorSteps.steps);
  const [htmlData, setHtmlData] = useState(aboutMe || "");
  const [displayMessage, setDisplayMessage] = useState("");
  /*
  // Define the isUrlValid function
  function isUrlValid(userInput) {
    if (userInput) {
      userInput = userInput.toLowerCase(); // Convert to lowercase
      const res = userInput.match(
        /(https?:\/\/.)?(www\.)?[-a-z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-z0-9@:%_.~#?&//=]*)/g
      );
      return res !== null;
    }
    return true;
  }
  function isYoutubeUrlValid(userInput) {
    if (!userInput || userInput === "https://") {
      return true;
    }
    userInput = userInput.toLowerCase(); // Convert to lowercase
    const res = userInput.match(
      /(https?:\/\/.)?(www\.)?[-a-z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-z0-9@:%_.~#?&//=]*)/g
    );
    if (res !== null) {
      return res.some(
        (url) => url.includes("youtube.com") || url.includes("youtu.be")
      );
    }
    return false;
  }
  function isLinkedinUrlValid(userInput) {
    if (!userInput || userInput === "https://") {
      return true;
    }
    userInput = userInput.toLowerCase(); // Convert to lowercase
    const res = userInput.match(
      /(https?:\/\/.)?(www\.)?[-a-z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-z0-9@:%_.~#?&//=]*)/g
    );
    if (res !== null) {
      return res.some((url) => url.includes("linkedin.com"));
    }
    return false;
  }
  function isTwitterUrlValid(userInput) {
    if (!userInput || userInput === "https://") {
      return true;
    }
    userInput = userInput.trim().toLowerCase()
    // Regex to match Twitter/X URLs properly
    const twitterRegex = /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)(\/[\w-]+)?\/?$/;
    return twitterRegex.test(userInput);
  }
  */
  // function ensureHttpsProtocol(url) {
  //   if (url && !url.startsWith("https://")) {
  //     return "https://" + url;
  //   }
  //   return url;
  // }
  const performSubmission = async () => {
    setExitLoading(true);
    try {
      const updateEducatorStep = httpsCallable(
        functions,
        "updateeducatorprofile"
      );
      await updateEducatorStep({ ...values, isSubmit: !edit, ip, page })
      const userRef = ref(database, `users/${uid}/educator`);
      if (!edit) {
        await update(userRef, {
          onboarding_complete: true,
        });
      }
      if (edit) {
        try {
          trackEvent(AnalyticsConstants.EDUCATOR_PROFILE_UPDATED, {
            user_id: uid,
          })
        } catch (trackingError) {
          await safeClientLogEvent({
            ...USER_LOGS_CLIENT.TRACKING_EVENT_FAILED,
            uid,
            source: "educatorProfileStep.jsx",
            emailInfo: null,
            metadata: null,
            error: trackingError?.message || null
          });
        }
      }
      dispatch(resetExperienceStepValues());
      edit ? setEdit(false) : navigate(paths.dashboardPage.path)
    } catch (error) {
      ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST)
    } finally {
      setExitLoading(false);
      setIsSubmitting(false);
    }
  }
  const handleAccept = async () => {
    setAgreementValue(true);
    setModalOpen(false);
    await performSubmission();
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const [values, setValues] = useState({
    avatar: "",
    aboutMe: aboutMe || "",
    // website: ensureHttpsProtocol(website) || "",
    // youtube: ensureHttpsProtocol(youtube) || "",
    // twitter: ensureHttpsProtocol(twitter) || "",
    // linkedin: ensureHttpsProtocol(linkedin) || "",
  })
  // Social link validation disabled (fields commented out)
  const validationSchema = Yup.object().shape({});
  /*
  const validateField = async (field, value) => {
    try {
      await validationSchema.validateAt(field, { [field]: value });
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    } catch (err) {
      setErrors((prev) => ({ ...prev, [field]: err.message }));
    }
  }
  */
  // const handleChange = (field) => (event) => {
  //   const value = event?.target ? event.target.value : event;
  //   setValues((prev) => ({ ...prev, [field]: value }));
  //   setTouched((prev) => ({ ...prev, [field]: true }))
  //   // social field per-field validation disabled
  //   // if (["website", "youtube", "twitter", "linkedin"].includes(field)) {
  //   //   validateField(field, value)
  //   // }
  // }
  // const handleBlur = (field) => () => {
  //   setTouched((prev) => ({ ...prev, [field]: true }));
  // }

  const handleSubmit = async (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    if (isSubmitting) return;

    try {
      await validationSchema.validate(values, { abortEarly: false });
      setErrors({});
    } catch (validationError) {
      const errObj = {};
      if (validationError && validationError.inner) {
        validationError.inner.forEach((ve) => {
          if (ve.path) errObj[ve.path] = ve.message;
        });
      }
      setErrors(errObj);

      const touchedObj = {};
      Object.keys(errObj).forEach((k) => (touchedObj[k] = true));
      setTouched((t) => ({ ...t, ...touchedObj }));
      setIsSubmitting(false);
      return;
    }
    let newDisplayMessage = "";
    if (!values.avatar && !profilePicture) {
      newDisplayMessage = "Must upload profile picture";
    } else if (
      characterCount < minCharacters ||
      characterCount > maxCharacters
    ) {
      newDisplayMessage = `About me text must be ${minCharacters}-${maxCharacters} characters`;
    }
    setDisplayMessage(newDisplayMessage);
    if (newDisplayMessage) {
      if (errorRef.current) {
        errorRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
      setExitLoading(false);
      setIsSubmitting(false);
      return;
    }
    if (!edit && agreementValue === null) {
      setModalOpen(true)
      setIsSubmitting(false);
      return
    }

    await performSubmission()
  }

  const handleDec = async () => {
    try {
      setLoaderValue(true)
      const updateEducatorStep = httpsCallable(
        functions,
        "updateeducatorprofile"
      );
      await updateEducatorStep({ ...values, onboarding_step: steps - 1, ip, page });
      dispatch(decrementSteps())
    } catch (error) {
      ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST)
    } finally {
      setLoaderValue(false)
    }
  };
  const handleAvatarUpload = (imageDataURL) => {
    setValues((prev) => ({ ...prev, avatar: imageDataURL }));
  };
  function countCharactersWithoutTags(html) {
    const textWithoutTags = html.replace(/(<([^>]+)>)/gi, "");
    return textWithoutTags.length;
  }
  const handleAboutMeChange = (value) => {
    const currentCharacterCount = countCharactersWithoutTags(value);
    setCharacterCount(currentCharacterCount);
    setValues((prev) => ({ ...prev, aboutMe: value}));
    setHtmlData(value);
    if (
      currentCharacterCount >= minCharacters &&
      currentCharacterCount <= maxCharacters
    ) {
      setDisplayMessage("");
    }
  };
  const handleExit = async () => {
    try {
      setExitLoading(true)
      const updateEducatorStep = httpsCallable(functions, "updateeducatorprofile");
      await updateEducatorStep({...values, ip, page});
      dispatch(resetExperienceStepValues());
      navigate(lastPageRoute || paths.home.path)
    } catch (err) {
      navigate(lastPageRoute || paths.home.path)
      ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST)
    } finally {
      setExitLoading(false)
    }
  };
  const handleCancelClick = () => {
    setEdit(false)
  }
  useEffect(() => {
    setAgreementValue(edit ? true : null);
  }, [edit]);
  useEffect(() => {
    setCharacterCount(values.aboutMe.length);
  }, [values.aboutMe]);
  useEffect(() => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlData;
    const text = tempDiv.textContent || tempDiv.innerText;
    setCharacterCount(text.length);
  }, [htmlData]);

  useEffect(() => {
    if ((values.avatar || profilePicture) && displayMessage === "Must upload profile picture") {
      setDisplayMessage("");
    }
    if (
      characterCount >= minCharacters &&
      characterCount <= maxCharacters &&
      displayMessage?.includes("About me text must be")
    ) {
      setDisplayMessage("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values.avatar,
    profilePicture,
    characterCount,
    displayMessage
  ])

  return (
    <>
      <ScrollToTop />
      <EducatorAgreement
        isOpenModal={isModalOpen}
        onClose={handleCloseModal}
        onAccept={handleAccept}
      />
      {
        !edit ?
          <EduAccFlowHeader handleExit={handleExit} steps={steps} />
          : ""
      }
      {!edit && exitLoading ? <DarkBgLoader height={"100vh"} /> : null}
      {loading || loaderValue ? (
        <Box height={'100vh'}><Loader /></Box>
      ) : (
        <Box
          component={"form"}
          onSubmit={handleSubmit}
          height={"auto"}
          pt={edit ? 0 : 12}
        >
          <Grid container sx={educatorProfileStepSX.gridMain}>
            <Grid
              lg={7}
              md={12}
              sm={12}
              xs={12}
              sx={educatorProfileStepSX.leftGrid}
              order={{ lg: 1, md: 2, sm: 2, xs: 2 }}
            >
              <Box
                display={"flex"}
                flexDirection={"column"}
                sx={{ width: "100%" }}
              >
                {
                  !dashboard &&
                  (<Typography pb={2} fontSize={28} >
                    Fill out your Educator Profile
                  </Typography>
                  )}

                <TitleText color={"primary"} pb={2}>
                  Educator
                </TitleText>
                <FullName color={"secondary"}>
                  {firstName} {lastName}
                </FullName>
                {!edit ? <AboutMe pt={3} color={"primary"} >
                  About Me
                </AboutMe>
                  :
                  <>
                    <Box sx={educatorProfileStepSX.aboutMeBox}>
                      <AboutMe color={"primary"} >
                        About Me
                      </AboutMe>
                      <Box sx={educatorProfileStepSX.editButtonsWrapper}>
                        <Button
                          type="button"
                          variant="contained"
                          sx={educatorProfileStepSX.cancelButton}
                          onClick={handleCancelClick}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="button"
                          variant="contained"
                          sx={educatorProfileStepSX.saveButton}
                          disabled={exitLoading}
                          onClick={handleSubmit}
                        >
                           {exitLoading ? (
                              <CircularProgress size={24} sx={{ color: "white" }} />
                            ) : (
                              "Save"
                            )}
                        </Button>
                      </Box>
                    </Box>
                  </>
                }
                <ReactQuill
                  theme="snow"
                  modules={modules}
                  formats={formats}
                  value={htmlData}
                  readOnly={exitLoading}
                  onChange={handleAboutMeChange}
                  style={{
                    zIndex: "auto",
                    marginTop: `${edit ? '30px' : '40px'}`
                  }}
                />
              </Box>
              {
                dashboard ? (
                  <Box sx={educatorProfileStepSX.characterCountBox}>
                    <Box sx={educatorProfileStepSX.errorTextBox}>
                      {characterCount < minCharacters ||
                        characterCount > maxCharacters ||
                        !values.avatar
                        ? displayMessage
                        : ""}
                    </Box>
                    <CharacterCount sx={{ order: { xs: 1, md: 2 } }}>
                      Character Count : <CountText>{characterCount}</CountText>
                    </CharacterCount>
                  </Box>
                ) : (
                  <Box width={"100%"}>
                    <CharacterCount>
                      Character Count : <CountText>{characterCount}</CountText>
                    </CharacterCount>
                      <ErrorBlockSmall  ref={errorRef}>
                        {(characterCount < minCharacters ||
                          characterCount > maxCharacters) &&
                          displayMessage}
                      </ErrorBlockSmall>
                  </Box>
                )
              }
            </Grid >
            <Grid
              lg={5}
              md={12}
              sm={12}
              xs={12}
              sx={educatorProfileStepSX.rightGrid}
              order={{ lg: 2, md: 1, sm: 1, xs: 1 }}
            >
              <Box maxWidth={{ md: "70%", lg: "100%", xlg: "100%" }}>
                <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
                  <Box position="relative">
                    <UploadAvatar onUpload={handleAvatarUpload} />
                  </Box>
                </Stack>
                {/* Social link inputs (website, youtube, twitter, linkedin) commented out per request */}
              </Box>
            </Grid>
          </Grid >
          {
            edit &&
            <MobileStickySubmit
              onSubmit={handleSubmit}
              disabled={exitLoading}
              handleCancelClick={handleCancelClick}
              exitLoading={exitLoading}
            />
          }
        </Box >
      )}{
        !edit ?
          <Footer>
            {/* Title ABOVE buttons on small screens */}
            {fromJob && (
              <Typography
                color="initial"
                sx={educatorFlowFooterSx.mobileSubtitle}
              >
                {title} - {subtitle}
              </Typography>
            )}
            <Grid container justifyContent="space-between" alignItems="center" p={2} position={"relative"}>
              {/* Previous Button */}
              <Grid xs={1}>
                {steps > 1 && (
                  <PreviousButton
                    variant="contained"
                    disabled={loading || loaderValue}
                    onClick={handleDec}
                  >
                    Previous
                  </PreviousButton>
                )}
              </Grid>
              {/* Continue Button & Error Block */}
              <Grid display="flex" justifyContent="flex-end" alignItems="center">
                <Box
                  sx={{
                    ...educatorProfileStepSX.errorBoxWrapper,
                    width: { md: displayMessage && '300px' },
                  }}>
                  <ErrorBlockLarge>
                    {characterCount < minCharacters ||
                      characterCount > maxCharacters ||
                      !values.avatar
                      ? displayMessage
                      : ""}
                  </ErrorBlockLarge>
                </Box>
                <ContinueButton
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={loaderValue || exitLoading}
                  sx={{ width: steps === 4 ? "100px" : "0px" }} // Correctly handles button width
                >
                  {steps === 4 ? "Submit" : "Continue"}
                </ContinueButton>
              </Grid>
              {/* Title CENTERED between buttons on large screens */}
              {fromJob && (
                <Grid
                  xs={12}
                  md="auto"
                  sx={educatorProfileStepSX.footerGridTitle}
                >
                  <Typography fontWeight={600} color="initial" textAlign={'center'}>
                    {title} - {subtitle}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Footer>
          : ''}
    </>
  );
};

export const MobileStickySubmit = ({ onSubmit, disabled, handleCancelClick, exitLoading }) => {
  const [footerOffset, setFooterOffset] = useState(0);
  const footerRef = useRef(null);

  useEffect(() => {
  const footerEl = document.querySelector(".site-footer");
  if (!footerEl) return;

  footerRef.current = footerEl;

  const handleScroll = () => {
    const rect = footerEl.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const overlap = windowHeight - rect.top;
    if (overlap > 0) {
      setFooterOffset(overlap);
    } else {
      setFooterOffset(0);
    }
  };

  window.addEventListener("scroll", handleScroll, { passive: true });
  handleScroll()

  return () => window.removeEventListener("scroll", handleScroll);
}, []);



  return (
    <Box sx={{...mobileStickySubmitSx.container, bottom: `${footerOffset}px`}}>
      <Box sx={mobileStickySubmitSx.buttonWrapper}>
        <Button
          variant="contained"
          sx={mobileStickySubmitSx.cancelButton}
          onClick={handleCancelClick}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={mobileStickySubmitSx.saveButton}
          disabled={exitLoading}
          onClick={onSubmit}
        >
           {exitLoading ? (
            <CircularProgress size={24} sx={mobileStickySubmitSx.circularProgress} />
          ) : (
            "Save"
          )}
        </Button>
      </Box>
    </Box>
  );
}